import React, { useContext } from "react";
import {
  Badge,
  Text,
  LegacyCard as Card,
  Checkbox,
  Collapsible,
  Icon,
  Layout,
  BlockStack,
  InlineStack,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";

// import contexts
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

// import helper
import { baseHelper } from "lib/helpers";

const Contact = () => {
  const {
    // learnMore,
    page,
  } = useContext(BrandingContext);
  const { currentUser = {}, cms = () => {} } = useContext(PrivateContext);
  const { /* plan, */ updatedAt = "" } = currentUser;
  const isGrowthAndAbovePlan = true; // baseHelper.isGrowthAndAbovePlan({ plan });
  const { isHideContact, handleChange } = page;
  const { IS_HIDE_CONTACT, CONTACT } = constant;

  const badge = (
    <InlineStack wrap={false}>
      <Badge status="warning">{cms("message.growthAndAbove")}</Badge>
      <Icon source="risk" color="orange" />
    </InlineStack>
  );

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.hideDetails.title")}
        description={cms("section.hideDetails.description")}
      >
        <Card
          title={[
            cms("section.hideDetails.title"),
            updatedAt && (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ),
          ]}
          // actions={[{ content: "Learn more", onAction: () => learnMore(cms("section.hideDetails.title"), "TODO: ") }]}
        >
          <Card.Section>
            <BlockStack gap="2">{cms("section.hideDetails.description")}</BlockStack>
            <br />
            <Checkbox
              label={cms("section.hideDetails.label.hide")}
              checked={isHideContact}
              helpText={cms("section.hideDetails.label.description")}
              onChange={(value) => isGrowthAndAbovePlan && handleChange(IS_HIDE_CONTACT, value, CONTACT)}
              disabled={!isGrowthAndAbovePlan}
            />
            <span>{!isGrowthAndAbovePlan && badge}</span>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(Contact), {
  feature: constant.HIDE_MC_BRANDING,
});
